import React, { useContext, useEffect } from 'react'
import { Link, useParams, useNavigate} from 'react-router-dom'
import COLORS  from '../../colors'
import './index.css'
import { Button } from '@material-ui/core'
import { AuthContext } from '../../App.js'
import { ReactComponent as ConfirmationImg } from '../../assets/confirmation.svg'
import { ReactComponent as AlertImg } from '../../assets/alert.svg'
import { ReactComponent as Scan } from '../../assets/scan.svg' 
import { isMobile } from 'react-device-detect'

	const Confirmation = ({ cid, processed,timeout, isShift, message, pageNumber, prevPage, onConfirmation, onBackToArticleList, onBackToCashierList, onBackToAddNewArticle, onBackToReport, onBackToStorne, onBackToPartialStorne }) => {

  	const { setPageNumber, signOut } = useContext(AuthContext)

  	const params = useParams()
   
  	const handleClick = () => {
		if(pageNumber===2){
			if(prevPage===6){
				setPageNumber(5)
			}else{
				setPageNumber(prevPage)
			}
			onConfirmation()
		}else if(pageNumber===8){
			onBackToAddNewArticle()
		}
  	}

  	const handleClose = () => {
		if(pageNumber===8){
			onBackToArticleList()
		}else if(pageNumber===4||pageNumber===10){
			setPageNumber(prevPage)
			if(pageNumber===4){
				onBackToStorne()
			}else{
				onBackToPartialStorne()
			}
		}else if(pageNumber===7){
			onBackToReport() 
		}else if(pageNumber===9){
			onBackToCashierList()
		}
  	}

  	useEffect(() => 
    {   
        const handleReload = async (e) => 
        {
            e.preventDefault()
            signOut(cid)
            setTimeout(() => window.location.assign(`/kekspos`, 0));
			window.removeEventListener('beforeunload', handleReload)    
            return false
        }

        window.addEventListener("beforeunload", handleReload)
         
        return () => 
        {    
            window.removeEventListener('beforeunload', handleReload) 
        }
  
  	}, [])

	if (timeout) { 

	}
  if(processed){
  return (
	  <div className="confirmation">
		  
	 {pageNumber===2?<div className="confirmation-txt">Plaćanje je uspješno izvršeno!</div>:null}
	 {pageNumber===4?<div className="confirmation-txt">STORNO transakcije je uspješno izvršen.</div>:null}
	 {pageNumber===7?(!isShift?<div className="confirmation-txt">Izvještaj za navedeno razdoblje je poslan.</div>:<div className="confirmation-txt">Smjena je zatvorena.</div>):null}
	 {pageNumber===8?<div className="confirmation-txt">Proizvod je uspješno dodan.</div>:null}
	 {pageNumber===9?<div className="confirmation-txt">Korisnik je uspješno dodan.</div>:null}
	 {pageNumber===10?<div className="confirmation-txt">Djelomični STORNO transakcije je uspješno izvršen.</div>:null}
	 <ConfirmationImg style={{ position:'relative', top:!isMobile?'15vh':'10vh'}}/>
	 {pageNumber===9?<div className="confirmation-subtxt" style={{ position:'relative', top:!isMobile?'20vh':'15vh'}}>Upisani podaci poslani su na korisničku navedenu e-mail adresu.</div>:null}
	 <div className="confirmation-btns" style={{top:!isMobile?'35vh':'25vh', width:!isMobile?'25rem':'90%'}}>
	 	{(pageNumber===2||pageNumber===8)?
	 	<Button size="large" 
			 	variant="contained"
			 	style={{	width:'100%', 
		         			height:'3rem',
				 			color:"#fff", 
				 			fontWeight:'bold', 
				 			backgroundColor: pageNumber===2?COLORS.green:COLORS.blue, 
				 			margin:5, 
				 			textTransform:'none',
							textDecoration:'none',
				 			"&:hover": {
								backgroundColor: pageNumber===2?COLORS.green:COLORS.blue
			  				} 
			  	}} 
				startIcon={pageNumber===2?<Scan style={{ marginLeft:-30 }}/>:null}
				component={Link}
				to={pageNumber===2?(prevPage===6?`/kekspos/${params.tid}/qr-artikl`:`/kekspos/${params.tid}/qr-iznos`):`/kekspos/${params.tid}/admin-artikl`} 
	 			onClick={ () => handleClick() }
	 	>
		 	{pageNumber===2?<div className="btn-confirmation-txt">GENERIRAJ NOVI QR KOD</div>:null}
			{pageNumber===8?<div className="btn-confirmation-txt">DODAJ NOVI PROIZVOD</div>:null}
	 	</Button>:null}
	 	<Button	size="large" 
				variant="contained"
				style={{	width:'100%',   
			  	 			height:'3rem',
				 			color: pageNumber===8?COLORS.blue:"#fff", 
				 			fontWeight:'bold', 
				 			backgroundColor:pageNumber===8?'#fff':COLORS.blue, 
				 			margin:5, 
				 			textTransform:'none',
							 textDecoration:'none',
				 			"&:hover": {
								backgroundColor:pageNumber===8?'#fff':COLORS.blue
			  	 			} 
			  	}}
				component={Link}
				to={pageNumber===8?
					`/kekspos/${params.tid}/admin-artikl`:(pageNumber===7?
						`/kekspos/${params.tid}/izvjestaji`:(pageNumber===9?
							`/kekspos/${params.tid}/admin-korisnik`:(pageNumber===4||pageNumber===10?(prevPage===3?
								`/kekspos/${params.tid}/povijest-transakcija`:`/kekspos/${params.tid}/izvjestaji`):`/kekspos/${params.tid}`)))}   
	 			onClick={() => handleClose()}
	 	>{pageNumber===8?<div>POVRATAK NA LISTU ARTIKALA</div>:(pageNumber===9?<div>POVRATAK NA LISTU KORISNIKA</div>:<div>OK, ZATVORI</div>)}
	 	</Button>
	 </div>
    </div>
  )
}else{
	return(
		<div className="confirmation">
			{timeout && <div className="confirmation-txt-rejection">Vrijeme za plaćanje je isteklo!</div>}
			{!timeout && pageNumber !== 7 && <div className="confirmation-txt-rejection" style={{ color: 'red' }}>Plaćanje nije izvršeno!</div>}
			{!timeout && pageNumber === 7 && isShift && <div className="confirmation-txt-rejection" style={{color:'red'}}>Smjena nije zatvorena, pokušajte ponovno!</div>}
			{!timeout && pageNumber === 7 && !isShift && <div className="confirmation-txt-rejection" style={{color:'red'}}>Izvještaj nije poslan, pokušajte ponovno!</div>}
			
			<AlertImg style={{position:'relative', top:!isMobile?'10vh':'5vh'}}/>
			<div className="confirmation-subtxt" style={{
				position:'relative', 
				top:!isMobile?'20vh':'15vh',
				whiteSpace: 'pre-line'
			}}>{message}</div>
			<div className="confirmation-btns" style={{top:!isMobile?'35vh':'25vh', width:!isMobile?'25rem':'90%'}}>
		 	{pageNumber===2||pageNumber===8?
			 	<Button size="large" 
					variant="contained"
					style={{	width:'100%', 
								height:'3rem',
								color:"#fff", 
								fontWeight:'bold', 
								backgroundColor: COLORS.green, 
								margin:5, 
								textTransform:'none',
								textDecoration:'none',
								"&:hover": {
								   backgroundColor: pageNumber===2?COLORS.green:COLORS.blue
								} 
					}} 
					startIcon={<Scan style={{ marginLeft:-30 }}/>}
					component={Link}
					to={pageNumber===2?(prevPage===6?`/kekspos/${params.tid}/qr-artikl`:`/kekspos/${params.tid}/qr-iznos`):`/kekspos/${params.tid}/admin-artikl`} 
					onClick={()=>handleClick()}
				>
				{pageNumber===2?<div className="btn-confirmation-txt">GENERIRAJ NOVI QR KOD</div>:null}
				{pageNumber===8?<div className="btn-confirmation-txt">DODAJ NOVI PROIZVOD</div>:null}
				</Button>:null}
				<Button	size="large" 
						variant="contained"
						style={{	width:'100%',   
									height:'3rem',
									color: "#fff", 
									fontWeight:'bold', 
									backgroundColor:COLORS.blue, 
									margin:5, 
									textTransform:'none',
									textDecoration:'none',
									"&:hover": {
								   		backgroundColor:pageNumber===8?'#fff':COLORS.blue
									} 
						}}
						component={Link}
						to={pageNumber===8?
							`/kekspos/${params.tid}/admin-artikl`:(pageNumber===7?
								`/kekspos/${params.tid}/izvjestaji`:(pageNumber===9?
									`/kekspos/${params.tid}/admin-korisnik`:(pageNumber===4||pageNumber===10?(prevPage===3?
										`/kekspos/${params.tid}/povijest-transakcija`:`/kekspos/${params.tid}/izvjestaji`):`/kekspos/${params.tid}`)))}    
						onClick={()=>handleClose()}
				>OK, ZATVORI</Button>
			</div>
	   </div>
	)}
}

export default Confirmation
